var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeElement01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1098,
    viewBox: "0 0 1920 1098",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-625.425 76.2048C297.793 371.298 545.523 724.501 1028.52 577.988C1414.92 460.776 2119.48 720.587 2423.46 865.143",
    stroke: "url(#paint0_linear_1043_40042)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-626.943 76.0434C304.662 350.726 578.046 702.254 1039.73 540.888C1409.08 411.795 2123 656.509 2433.79 795.003",
    stroke: "url(#paint1_linear_1043_40042)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-624.984 75.7498C314.822 324.402 619.405 673.545 1053.54 493.51C1400.84 349.482 2124.68 574.911 2443.19 705.629",
    stroke: "url(#paint2_linear_1043_40042)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-619.374 76.0771C325.118 301.755 655.726 647.975 1065.11 452.361C1392.62 295.87 2123.17 504.176 2447.5 627.89",
    stroke: "url(#paint3_linear_1043_40042)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-631.98 73.2094C314.088 286.709 657.955 631.089 1054.07 427.535C1370.96 264.693 2104.33 463.885 2431.41 583.836",
    stroke: "url(#paint4_linear_1043_40042)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-634.013 73.214C313.391 264.567 680.464 605.11 1052.19 387.658C1349.57 213.697 2086.85 396.254 2418.31 509.278",
    stroke: "url(#paint5_linear_1043_40042)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-632.306 72.7025C314.087 235.878 709.08 570.669 1049.32 336.488C1321.52 149.144 2061.58 310.425 2397.59 414.483",
    stroke: "url(#paint6_linear_1043_40042)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-627.04 72.461C316.114 211.032 734.091 540.046 1046.45 292.088C1296.33 93.7215 2036.93 236.33 2376 332.43",
    stroke: "url(#paint7_linear_1043_40042)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-623.317 93.4925C296.952 393.754 537.738 746.575 1025.95 604.708C1416.52 491.215 2118.05 754.746 2420 900.698",
    stroke: "url(#paint8_linear_1043_40042)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-625.46 93.269C303.994 373.45 570.54 725.347 1037.97 568.073C1411.92 442.253 2123.41 691.023 2432.41 831.136",
    stroke: "url(#paint9_linear_1043_40042)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-623.485 92.9919C314.802 347.322 612.74 697.071 1052.93 521.013C1405.08 380.166 2126.97 609.813 2443.9 742.242",
    stroke: "url(#paint10_linear_1043_40042)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-617.861 93.3567C325.66 324.852 649.807 671.881 1065.5 480.136C1398.05 326.739 2127.07 539.39 2450.01 664.89",
    stroke: "url(#paint11_linear_1043_40042)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-630.452 90.4125C314.931 309.797 652.437 655.09 1054.98 455.346C1377.01 295.55 2109.08 499.149 2434.86 620.923",
    stroke: "url(#paint12_linear_1043_40042)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-632.496 90.4026C314.737 287.752 675.639 629.394 1054 415.638C1356.69 244.634 2093.06 431.702 2423.41 546.612",
    stroke: "url(#paint13_linear_1043_40042)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-630.768 89.9063C316.094 259.199 705.173 595.319 1052.29 364.683C1329.99 180.174 2069.65 346.084 2404.76 452.103",
    stroke: "url(#paint14_linear_1043_40042)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-625.475 89.7031C318.698 234.482 730.995 565.018 1050.42 320.465C1305.96 124.822 2046.59 272.15 2384.96 370.269",
    stroke: "url(#paint15_linear_1043_40042)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_40042",
    x1: 918.323,
    y1: 398.627,
    x2: 851.289,
    y2: 648.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1043_40042",
    x1: 916.223,
    y1: 361.964,
    x2: 854.908,
    y2: 613.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1043_40042",
    x1: 913.797,
    y1: 315.273,
    x2: 859.419,
    y2: 568.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1043_40042",
    x1: 911.785,
    y1: 275.161,
    x2: 863.389,
    y2: 531.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1043_40042",
    x1: 893.804,
    y1: 251.038,
    x2: 848.552,
    y2: 508.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1043_40042",
    x1: 879.747,
    y1: 212.697,
    x2: 840.204,
    y2: 472.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1043_40042",
    x1: 862.169,
    y1: 163.938,
    x2: 829.953,
    y2: 427.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1043_40042",
    x1: 847.131,
    y1: 122.041,
    x2: 821.45,
    y2: 389.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1043_40042",
    x1: 919.34,
    y1: 425.661,
    x2: 850.927,
    y2: 674.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1043_40042",
    x1: 918.017,
    y1: 389.074,
    x2: 855.203,
    y2: 639.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1043_40042",
    x1: 916.65,
    y1: 342.581,
    x2: 860.777,
    y2: 595.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1043_40042",
    x1: 915.546,
    y1: 302.637,
    x2: 865.643,
    y2: 558.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1043_40042",
    x1: 898.042,
    y1: 278.496,
    x2: 851.272,
    y2: 535.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1043_40042",
    x1: 884.799,
    y1: 240.229,
    x2: 843.709,
    y2: 499.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1043_40042",
    x1: 868.261,
    y1: 191.567,
    x2: 834.443,
    y2: 454.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1043_40042",
    x1: 854.115,
    y1: 149.752,
    x2: 826.768,
    y2: 416.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeElement01);
export default __webpack_public_path__ + "static/media/be_element_01.cd622f337569d35f332d9e19f8ff80f2.svg";
export { ForwardRef as ReactComponent };